import classNames from 'classnames'

import { Translation } from 'cng-common/features/translations/components/translation'

import styles from './Attention.module.scss'

interface IProps {
  translation: string
}

export const Attention = ({ translation }: IProps) => {
  return (
    <div className={styles.info}>
      <i className={classNames('kbase kbase-info', styles.info__icon)}></i>
      <Translation span text={translation} />
    </div>
  )
}
